class CarouselSwiper extends HTMLElement {
  constructor() {
    super();
    this.testimonialsContainer = this.closest(".testimonials-wrapper");
    this.swiperButtonNext = this.testimonialsContainer.querySelector(
      ".swiper-button-next"
    );
    this.swiperButtonPrev = this.testimonialsContainer.querySelector(
      ".swiper-button-prev"
    );
    this.swiperScrollbar =
      this.testimonialsContainer.querySelector(".swiper-scrollbar");
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1.15,
      spaceBetween: 20,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 2.7,
          spaceBetween: 12,
        },
      },
      navigation: {
        nextEl: this.swiperButtonNext,
        prevEl: this.swiperButtonPrev,
      },
      scrollbar: {
        el: this.swiperScrollbar,
      },
    });
  }
}

customElements.define("carousel-swiper", CarouselSwiper);
